import { default as currentCaseReducer } from './cases/reducer';
import { default as casesListingReducer } from './casesListing/reducer';
import { reducer as pepperReducer } from '../pages/CaseDetailsPage/Pepper/store';
import { reducer as tasksReducer } from '../Tasks/store';
import { reducer as vulnerabilitiesReducer } from '../Vulnerabilities/store';
import { errorReducer as casePepperErrorReducer } from '../infrastructure/Pepper/store';
import { reducer as repaymentStrategyReducer } from '../RepaymentStrategy/store';

const reducers = {
  currentCase: currentCaseReducer,
  cases: casesListingReducer,
  cmPepper: pepperReducer,
  cmTasks: tasksReducer,
  vulnerabilities: vulnerabilitiesReducer,
  casePepperError: casePepperErrorReducer,
  repaymentStrategy: repaymentStrategyReducer,
};

export default reducers;
